// Textos do módulo Gestão (Auditoria e Minhas avaliações). Mesmo esquema do
// painel do SGP (ver ../sgp/i18n.js).

const PT = {
  NEUXS_GESTAO: {
    TITULO: 'Gestão',
    MENU: {
      MONITORAMENTO: 'Monitoramento',
      TV: 'Modo TV',
      AUDITORIA: 'Auditoria',
      RELATORIO: 'Relatório da IA',
      AVALIACOES: 'Avaliações',
      RETENCAO: 'Retenção e vendas',
      CUSTOS: 'Custos',
      CONFIGURACAO: 'Configuração da auditoria',
      MINHAS: 'Minhas avaliações',
    },
    PAGINAS: {
      MONITORAMENTO: 'Monitoramento',
      TV: 'Modo TV',
      RELATORIO: 'Auditoria · Relatório da IA',
      AVALIACOES: 'Auditoria · Avaliações',
      RETENCAO: 'Auditoria · Retenção e vendas',
      CUSTOS: 'Auditoria · Custos',
      CONFIGURACAO: 'Auditoria · Configuração',
      MINHAS: 'Minhas avaliações',
    },
    POR_PESSOA: '🔒 por pessoa',
    FILTROS_BOTAO: 'Filtros',
    SEM_ACESSO:
      'Você não tem acesso a esta tela. A Auditoria é liberada por pessoa: peça ao suporte da Nexus.',
    DESLIGADA:
      'A análise dos atendimentos está desligada para esta empresa: as avaliações aparecem aqui quando ela for ligada.',
    ERRO: 'Não consegui carregar. Tente de novo.',
    TENTAR: 'Tentar de novo',
    PERIODO: 'Período',
    DIAS: 'Últimos {n} dias',
    VAZIO: 'Nada no período.',
    RESUMO: {
      NOTA: 'Nota média da equipe',
      AVALIADAS: 'Atendimentos avaliados',
      ALERTAS: 'Com alerta grave',
      ABAIXO: 'Notas abaixo de 6',
      VS: '{sinal} {n} vs período anterior',
      SEM_ANTERIOR: 'sem período anterior',
    },
    RANKING: 'Ranking de qualidade',
    ATENDENTE: 'Atendente',
    NOTA: 'Nota',
    AVALIADAS: 'Avaliadas',
    LISTA: 'Avaliações',
    TODOS: 'Todos os atendentes',
    FILTROS: {
      TODAS: 'Qualquer nota',
      BAIXA: 'Abaixo de 6',
      ALERTA: 'Com alerta grave',
    },
    MAIS: 'Mostrar mais',
    ESCOLHA: 'Escolha uma avaliação para ver o detalhe.',
    AJUSTADA: 'ajustada',
    ALERTAS: {
      grosseria: 'Grosseria',
      promessa_indevida: 'Promessa indevida',
      dado_sensivel: 'Dado sensível exposto',
      abandono: 'Cliente abandonado',
      informacao_errada: 'Informação errada',
    },
    DETALHE: {
      ATENDENDO: '{atendente} atendendo {cliente}',
      CONVERSA: 'Conversa #{id}',
      ABRIR: 'Abrir conversa',
      FORTES: 'Pontos fortes',
      MELHORAR: 'A melhorar',
      SUGESTAO: 'Sugestão do analista',
      TRECHOS: 'Conversa, com os trechos citados',
      PRIMEIRA: '1ª resposta: {t}',
      ESPERA: 'Maior espera: {t}',
      NOTA_DA_IA: 'Nota do auditor: {n}',
      AJUSTE: 'Ajustada por {por}: {motivo}',
      AJUSTAR: 'Ajustar nota',
      NOVA_NOTA: 'Nova nota (0 a 10)',
      MOTIVO: 'Motivo do ajuste',
      SALVAR: 'Salvar ajuste',
      CANCELAR: 'Cancelar',
      DESFAZER: 'Voltar à nota do auditor',
      REFAZER: 'Analisar de novo',
      REFAZENDO:
        'O auditor vai ler o atendimento de novo. Atualize em alguns segundos.',
      AUTORES: {
        cliente: 'Cliente',
        ia: 'IA',
        automatica: 'Mensagem automática',
      },
      RESULTADOS: {
        cancelou: 'Cancelou',
        retido: 'Retido',
        em_negociacao: 'Em negociação',
        contratou: 'Contratou',
        upgrade: 'Upgrade',
        downgrade: 'Downgrade',
        nenhum: '',
      },
    },
    RETENCAO: {
      PEDIDOS: 'Pedidos de cancelamento',
      RETIDOS: 'Retidos',
      TAXA: '{n}% de retenção',
      CANCELADOS: 'Cancelados',
      CONFIRMADOS: '{n} confirmados no SGP',
      NEGOCIACAO: 'Em negociação',
      CONTRATACOES: 'Contratações',
      UPGRADES: '{n} upgrades',
      SALDO: 'Saldo',
      SALDO_DICA: 'contratações − cancelados',
      MOTIVOS: 'Por que cancelam',
      MOTIVOS_DICA:
        'Como a IA escreveu em cada conversa; o relatório da IA agrupa em categorias.',
      LEITURA: 'Leitura da IA',
      LEITURA_DICA: 'do último relatório ({de} a {ate})',
      OFERTAS: 'O que retém',
      OFERTA: 'Oferta',
      OFERTADA: 'Ofertada',
      TAXA_CURTA: 'Taxa',
      POR_QUEM: 'Retenção por quem atendeu',
      QUEM: 'Quem',
      CONTRATACOES_ORIGEM: 'De onde vieram as contratações',
      ORIGEM: {
        ia: 'IA',
        equipe: 'Equipe',
      },
      LISTA: 'Atendimentos analisados',
      QUANDO: 'Quando',
      CLIENTE: 'Cliente',
      RESULTADO: 'Resultado',
      NO_SGP: 'No SGP',
      MOTIVO: 'Motivo',
      ATENDEU: 'Atendeu',
      RESUMO: 'Resumo da IA',
      SGP: {
        aguardando: 'conferindo',
        cancelado: '✓ Cancelado',
        ativo: '⚠ Continua ativo',
        sem_contrato: 'sem contrato',
        sem_integracao: 'sem SGP',
        erro: 'SGP não respondeu',
      },
    },
    CUSTOS: {
      SEM_PLANO:
        'A empresa ainda não tem plano cadastrado. Fale com o suporte da Nexus.',
      PLANO: 'Plano {nome}',
      CICLO: 'Ciclo de {de} a {ate}',
      FALTAM: 'fecha em {fecha} · faltam {n} dia(s)',
      FECHADO: 'ciclo fechado',
      MENSAGENS: 'Mensagens pela API oficial',
      MENSAGENS_DICA:
        'Respostas e modelos enviados pela API oficial da Meta, inclusive os disparos. O que sai pelo aparelho não conta.',
      INCLUSAS: 'de {n} inclusas',
      ILIMITADAS: 'sem limite no plano',
      DETALHE: '{respostas} respostas · {modelos} modelos e disparos',
      EXCEDENTES: '{n} acima da franquia × {preco}',
      AVISO_80: 'Você já usou {uso}% da franquia de mensagens deste ciclo.',
      AVISO_100:
        'A franquia deste ciclo acabou. A IA continua respondendo normalmente; cada mensagem a mais custa {preco} e entra na fatura do ciclo.',
      PROJECAO: 'No ritmo atual, o ciclo fecha com cerca de {n} mensagens.',
      RELATORIOS: 'Relatórios da IA',
      RELATORIOS_USO: '{usados} de {inclusos} do plano',
      RELATORIOS_EXTRAS: '{n} extra(s) · {valor}',
      SEM_AUDITORIA: 'Não incluso no plano',
      FATURA: 'Fatura do ciclo',
      MENSALIDADE: 'Mensalidade',
      EXCEDENTE: 'Mensagens acima da franquia',
      EXTRAS: 'Relatórios extras',
      ATE_AGORA: 'Até agora',
      PREVISAO: 'Previsão no fechamento',
      SUGESTAO:
        'No seu uso, o plano {plano} sairia por {valor} neste ciclo ({economia} a menos). Fale com o suporte da Nexus para trocar.',
      POR_DIA: 'Mensagens por dia',
      RITMO: 'ritmo da franquia ({n}/dia)',
      CICLOS: 'Ciclos fechados',
      PERIODO: 'Período',
      PLANO_COLUNA: 'Plano',
      MENSAGENS_COLUNA: 'Mensagens',
      TOTAL: 'Total',
    },
    CONFIG: {
      CRITERIOS: 'Critérios e pesos',
      CRITERIOS_DICA:
        'O peso de cada critério na nota. A agilidade é medida pelo sistema (tempos dentro do horário de atendimento), não pela IA.',
      ROTEIRO: 'Roteiro de atendimento da empresa',
      ROTEIRO_DICA:
        'O que a empresa espera do atendente, uma regra por linha. O auditor compara a conversa com ele.',
      ATENDENTE_VE:
        'O atendente vê as próprias avaliações (Gestão → Minhas avaliações)',
      ENVIO: 'Envio do relatório da IA',
      ENVIA_SOZINHO:
        'Mandar o semanal e o mensal por e-mail assim que ficarem prontos, para quem tem acesso à Auditoria',
      EMAILS: 'E-mails a mais (um por linha)',
      EMAILS_DICA:
        'Por exemplo, a diretoria. Sai pelo mesmo e-mail que o sistema já usa para as notificações.',
      SALVAR: 'Salvar configuração',
      SALVO: 'Configuração salva.',
      LIGADA: 'Análise dos atendimentos ligada · modelo {modelo}',
      DESLIGADA:
        'Análise dos atendimentos desligada: o suporte da Nexus liga no Super Admin.',
    },
    RELATORIO: {
      LISTA: 'Relatórios',
      GERAR_7: 'Gerar agora (7 dias)',
      GERAR_30: 'Gerar agora (30 dias)',
      AGENDA:
        'Sai sozinho toda segunda às 6h (a semana anterior) e no dia 1º (o mês anterior). Os números vêm do banco; a IA escreve a análise em cima deles.',
      COTA: 'Plano: {inclusos} relatório(s) por ciclo · restam {restantes} até {fecha}. O automático e o "Gerar agora" usam a mesma cota.',
      COMPRA_TITULO: 'Os relatórios do plano acabaram',
      COMPRA_TEXTO:
        'Seu plano inclui {inclusos} relatório(s) por ciclo, e os deste ciclo já foram usados (o próximo ciclo começa em {fecha}). Quer comprar um relatório extra por {preco}? O valor entra na fatura do ciclo.',
      COMPRA_SO_ADMIN:
        'Só o administrador da empresa pode comprar relatório extra.',
      COMPRAR: 'Comprar e gerar ({preco})',
      CANCELAR: 'Agora não',
      EXTRA: 'extra',
      VAZIO:
        'Nenhum relatório ainda. O primeiro sai na próxima segunda, ou gere agora.',
      ESCOLHA: 'Escolha um relatório.',
      TIPOS: {
        semanal: 'Semanal',
        mensal: 'Mensal',
        manual: 'Gerado na hora',
      },
      STATUS: {
        gerando: 'Gerando…',
        falhou: 'Falhou',
      },
      GERANDO:
        'A IA está lendo os atendimentos do período. Leva cerca de um minuto.',
      FALHOU: 'Não consegui gerar este relatório: {erro}',
      PERIODO: '{de} a {ate}',
      RESUMO: 'Resumo',
      NUMEROS: {
        conversas: 'Conversas',
        ia_sem_humano: 'IA sem humano',
        csat: 'CSAT',
        nota: 'Nota da equipe',
        retencao: 'Retenção',
        oficiais: 'Mensagens API oficial',
      },
      ANTERIOR: 'antes: {valor}',
      ASSUNTOS: 'Do que os clientes falaram',
      MOTIVOS: 'Por que pediram para cancelar',
      MOTIVOS_DICA: '{retidos} de {total} retidos',
      NOVO: 'novo',
      CATEGORIAS_DICA:
        'Agrupados pela IA, mantendo as categorias do relatório anterior.',
      SECOES: {
        assuntos: 'Assuntos',
        cancelamentos: 'Cancelamentos e retenção',
        suporte: 'Rede e suporte técnico',
        equipe: 'Equipe',
        ia: 'IA',
        custos: 'WhatsApp oficial',
      },
      RECOMENDACOES: 'Recomendações, por prioridade',
      CONVERSA: 'conversa #{id}',
      BAIXAR: 'Baixar PDF',
      ENVIAR: 'Enviar por e-mail',
      ENVIO_TITULO: 'Enviar este relatório por e-mail',
      ENVIO_DICA:
        'Vai com o PDF anexado, pelo e-mail do sistema. Um e-mail por pessoa.',
      COM_ACESSO: 'Quem tem acesso à Auditoria',
      SEM_ACESSO: 'Ninguém com acesso à Auditoria tem e-mail cadastrado.',
      OUTROS: 'Outros e-mails (separados por vírgula)',
      MANDAR: 'Enviar',
      ENVIADO: 'Enviado para {n} e-mail(s).',
      ERRO_PDF: 'Não consegui gerar o PDF.',
    },
    MONITOR: {
      HOJE: 'Hoje',
      DIAS: '{n} dias',
      CAIXAS: 'Todas as caixas',
      TIMES: 'Todos os times',
      MODO_TV: 'Modo TV',
      ATUALIZA: 'Atualiza a cada minuto',
      KPI: {
        CONVERSAS: 'Conversas',
        AGORA: 'Abertas agora',
        AGORA_DICA: '{ia} com a IA · {equipe} com a equipe',
        FILA: 'Na fila',
        FILA_DICA: '{n} acima de {min} min',
        RESOLVIDAS: 'Resolvidas',
        PRIMEIRA: '1ª resposta da equipe',
        TEMPO: 'Tempo médio de atendimento',
        CSAT: 'CSAT',
        CSAT_DICA: '{n} respostas',
        SENTIMENTO: 'Sentimento',
        SENTIMENTO_DICA: '{n} conversas abertas',
        VS: '{sinal} {n}% vs {antes}',
        ONTEM: 'ontem até agora',
        ANTES: 'período anterior',
      },
      POR_HORA: 'Conversas novas por hora',
      POR_DIA: 'Conversas novas por dia',
      SO_IA: 'Ficaram com a IA',
      COM_EQUIPE: 'Passaram pela equipe',
      SENTIMENTO: 'Sentimento dos clientes',
      SENTIMENTO_DICA: 'conversas abertas agora',
      IA: 'IA',
      SEM_HUMANO: 'Sem humano',
      RESPOSTA: 'Resposta média',
      ERROS: 'Erros',
      ESCALOU: 'Por que passou para a equipe',
      EQUIPE: 'Equipe',
      ATENDENTE: 'Atendente',
      AGORA: 'Agora',
      RESOLVIDAS: 'Resolvidas',
      PRIMEIRA: '1ª resp.',
      TEMPO: 'Tempo médio',
      STATUS: {
        online: 'Online',
        busy: 'Ocupado',
        offline: 'Offline',
      },
      DISPAROS: 'Disparos',
      ENVIADOS: 'Enviados',
      ENTREGUES: 'Entregues',
      LIDOS: 'Lidos',
      RECUSADOS: 'Recusados pela Meta',
      ASSUNTOS: 'Assuntos (etiquetas)',
      SLA: 'Esperando acima de {min} min',
      SLA_VAZIO: 'Ninguém esperando além do tempo.',
      SEMANA: 'Movimento da semana',
      SEMANA_DICA: 'conversas novas por dia e hora, últimos 7 dias',
    },
    TV: {
      TITULO: 'Operação',
      AO_VIVO: 'Ao vivo',
      DISCRETO: 'Modo discreto',
      SOM: 'Som dos alertas',
      TELA_CHEIA: 'Tela cheia',
      SAIR: 'Sair do modo TV',
      HOJE: 'Conversas hoje',
      NA_FILA: 'Na fila',
      EQUIPE: 'Com a equipe',
      IA: 'Com a IA',
      IA_RESOLVEU: 'IA resolveu',
      SENTIMENTO: 'Sentimento',
      FILA: 'Fila de espera',
      FILA_SLA: 'SLA {min} min',
      FILA_VAZIA: 'Ninguém esperando.',
      ONLINE: 'Equipe online',
      ONLINE_DICA: 'conversas abertas',
      NINGUEM: 'Ninguém online.',
      VISTAS: {
        FEED: 'Conversas em tempo real',
        RANKING: 'Equipe hoje',
        TEIA: 'Nexus Neural',
      },
      MASCARADOS: 'dados pessoais mascarados',
      OCULTA: 'mensagem oculta (modo discreto)',
      SEM_MENSAGENS: 'Esperando a próxima mensagem…',
      DESTAQUE: 'Precisa de atenção',
      DESTAQUE_DICA: 'fixo até alguém assumir',
      SEM_DESTAQUE: 'Nenhum cliente irritado esperando.',
      ESPERA: 'esperando há {t}',
      ALERTAS: 'Alertas',
      SEM_ALERTAS: 'Tudo em ordem.',
      ALERTA: {
        irritado: '{cliente} ficou 😡 irritado(a)',
        sla: '{n} cliente(s) acima do tempo na fila',
        erro_ia: 'IA com {n} erro(s) nos últimos 30 min',
      },
      AUTORES: {
        cliente: 'escreveu',
        ia: 'IA',
        equipe: 'Equipe',
        automatica: 'Automática',
      },
      PARA: 'para {cliente}',
      RODAPE: 'Atualiza sozinho · dados pessoais mascarados',
    },
    MINHAS: {
      MEDIA: 'Sua nota média (30 dias)',
      AVALIADAS: 'Atendimentos avaliados (30 dias)',
    },
  },
};

export default { pt_BR: PT, en: PT };
